export default {
  企业申请认证: 'Enterprise certification application',
  展厅服务: 'Exhibition Space Service',
  查看更多: 'View More',
  于: '于',
  发布: 'Post',
  云展动力首页: 'Home',
  扫码下载: 'Scan Code To Download',
  云展动力APP: 'Cloud Momentum APP',
  分享: 'Share',
  参展报名: 'Exhibitor Registration',
  申请加入: 'Exhibitor Registration',
  '3D展览': 'Virtual Exhibition',
  了解更多: 'Learn More',
  进场人数: 'Visits',
  访问人数: 'Visits',
  参展企业: 'Exhibitors',
  入链企业: 'Exhibitors',
  企业展品: 'Exhibits',
  供应产品: 'Exhibits',

  企业3D: '3D Display',
  元宇宙会客厅: '3D Display',

  面议: 'Negotiable',
  '3D产品': '360° Product Photos',
  '3D企业': 'Virtual Company Tour',
  '3D全景': '3D Panorama',
  展品: 'Exhibits',
  直播: 'Live Streams',
  请输入关键词: 'Please Enter Keyword',
  服务与承诺: 'Service and Commitment',
  主页: 'Home',
  在线洽谈: 'Chat Now',
  // no use
  产品: 'Product',
  参展的展览: 'Participated Exhibitions',
  我的直播间: 'My Live Streams',
  直播预告: 'Preview',
  直播中: 'Live Now',
  直播回放: 'Playback',
  预告: 'Preview',
  联系信息: 'Contact Info',
  联系方式: 'Contact Info',
  收藏: 'Save',
  取消收藏: 'Removed',
  // no use
  回放: 'Replay',
  产品规格: 'Product Specifications',
  立即报名: 'Sign up Now',
  立即注册: 'Register Now',
  修改并登录: 'Find Now',
  '3D企业全貌': 'Company 3D Display',
  企业未上传内容提示: 'No content available yet. Please stay tuned.',
  账号注册: 'User Registration',
  找回密码: 'Find My Password',
  协议: 'Terms',
  还没有账号: 'Don’t have an account yet?',
  微信订阅号: 'WeChat Subscription Account',
  微信服务号: 'WeChat Service Account',
  免责声明详情:
    'All event information displayed on this website is merely for reference. While the event information here has been verified to the best of our abilities, we cannot guarantee that there are no mistakes, potential cancellation or postponement. Before attending any event posted here, please contact the corresponding Organizer to confirm event details first. This website will not be held responsible or liable in any way for any loss stemming directly or indirectly from the accuracy, completion, legality, reliability, feasibility and quotability of the event information here. ',
  参展商报名: 'Exhibitor Registration',
  上一页: 'Back',
  下一页: 'Next ',
  敬请期待: 'Stay tuned!',
  企业3D全貌: 'Enterprise 3D Panorama',
  暂无参展企业: 'No exhibitors available yet.',
  打开微信扫一扫看企业: 'Scan to View This Enterprise on WeChat',
  打开微信扫一扫看展览: 'Scan to View This Exhibition on WeChat',
  也可截图分享给您好友: 'Save Screenshot and Share With Friends',
  '抱歉,没有找到': 'Sorry, no matching',
  推荐列表: 'Recommended for You',
  免责声明: 'Disclaimer',
  您的浏览器不支持video标签: "Your browser doesn't support the video tag.",
  提交: 'Submit',
  微信扫一扫: 'Scan to View on WeChat',
  搜索匹配不到参展企业提示1: "Sorry, we didn't find it",
  搜索匹配不到参展企业提示2: 'Related exhibitors',
  线下展览: 'Offline Exhibition',
  会议: 'Conferences',
  模型: 'Design',
  海报: 'Poster Template',
  复制链接: 'Copy URL',
  我的云企业: 'Our Company',
  产品服务: 'Our Exhibits',
  已参展的展览: 'Participated Exhibitions',
  云展览: 'Cloud Exhibitions',
  我的云直播: 'Our Live Streams',
  企业动态: 'Company News',
  投资: 'Investors',
  我的投资机构: 'My Investors',
  我的对外投资: 'My Investees',
  暂无数据: 'No data available yet.',
  主营产品: 'Main Products',
  动态详情: 'Dynamic details',
  请输入正确的验证码: 'Please enter correct verify code',
  收藏成功: 'Saved!',
  取消收藏成功: 'Removed!',
  '暂不认证,跳过': 'Do not apply for enterprise certification, Skip',
  请注册账号: 'Please register an account',
  去完善名片: 'Complete contact info on my business card now.',
  请完善个人名片信息: 'Please complete your business card info.',
  请完善当前语言的个人名片信息: 'Please complete the personal business card information in the current language',
  已退出登录: 'logout Successful',
  已发布的会议: 'My Conferences',
  已发布的展览: 'My Exhibitions',
  发送: 'Send',
  Ta的名片: 'Her/His business card',
  回放页: 'Live Stream Replays',
  回到顶部: 'Back to Top',
  友情链接: 'FriendLinks',
}
